import React from "react";
import Link from '@mui/material/Link';
import { Link as RouterLink } from "react-router-dom";

import Typography from '@mui/material/Typography';

import { getHashtags } from '../util/getHashtags';
import { Pages } from "../type/TypePages";

const hashtags = getHashtags();
interface AllHashtagsProps {
  page: Pages;
}

const AllHashtags = (props: AllHashtagsProps) => {
  const { page } = props;

  return (
    <React.Fragment>
      {
        hashtags.map((hashtag, index) => {
          return (
            <Typography
              key={`hashtag-${index}`}
              component="p"
              variant="caption"
            >
              <Link
                color="inherit"
                to={`/${page}?filter=${hashtag}`}
                component={RouterLink}
              >
                #{hashtag}
              </Link>
            </Typography>
          )
        })
      }
    </React.Fragment>
  )
}

export default React.memo(AllHashtags);